document.addEventListener("DOMContentLoaded", function () {
    const GRID = document.querySelector('#collectionmodalcontainer #product-grid');
    const PAGINATION = document.querySelector('#product-grid-Pagination');
    if (!GRID || !PAGINATION) return;
    const PAGE_SIZE = 36;
    const availableBuffer = [];
    let isLoading = false;
    let nextPageUrl =
    PAGINATION.querySelector('a[href*="page="]')?.href || null;
    let allPagesLoaded = false;
    async function fetchPage(url) {
      if (!url) return null;

      const res = await fetch(url, { cache: "force-cache" });
      const html = await res.text();

      // 🔥 Faster than DOMParser
      const temp = document.createElement('div');
      temp.innerHTML = html;

      // 🎯 Extract only required container
      const newContainer = temp.querySelector(
        '#collectionmodalcontainer #product-grid'
      );
      const currentContainer = document.querySelector('#collectionmodalcontainer #product-grid');
      
      if (newContainer && currentContainer) {
        currentContainer.insertAdjacentHTML('beforeend', newContainer.innerHTML);
      }

      // 🔄 Update pagination
      const newPagination = temp.querySelector('#product-grid-Pagination');
      if (newPagination) {
        PAGINATION.innerHTML = newPagination.innerHTML;
      }

      // ➡️ Get next page URL
      const next = newPagination?.querySelector('a[href*="page="]');
      return next ? next.href : null;
    }
    async function loadMore() {
      if (isLoading || allPagesLoaded || !nextPageUrl) return;
      isLoading = true;
      try {
        nextPageUrl = await fetchPage(nextPageUrl);
        if (!nextPageUrl) {
          allPagesLoaded = true;
          document.querySelector('#product-grid-Pagination').innerHTML = PAGINATION.innerHTML
        }
      } catch (e) {
        console.error('Load error:', e);
      }
      isLoading = false;
    }
    let scrollTimeout;
    window.addEventListener('scroll', () => {
      if (scrollTimeout) return;
      scrollTimeout = setTimeout(() => {
        scrollTimeout = null;
        const nearBottom = document.documentElement.scrollTop;
        if (nearBottom > 150) {
          loadMore();
        }
      }, 150);
    });
  });
// document.addEventListener('DOMContentLoaded', function () {
//   const target = document.querySelector('.pagination');
  
//   if (target) {
//     window.observer1 = new IntersectionObserver((entries) => {
//       entries.forEach((entry) => {
//         if (entry.isIntersecting && document.querySelector('.pagination .btnLoder')) {
//           document.querySelector('.pagination .btnLoder').click();
//         }
//       });
//     });

//     window.observer1.observe(target);
    
//     window.onClickCollectionPagination = async (link, event) => {
//       event.preventDefault();

//       link.style.width = `${link.offsetWidth}px`;
//       link.style.height = `${link.offsetHeight}px`;
//       link.innerHTML = `
//         <div class="st-results-loader">
//           <div class="result-loading" style="text-align: center">
//             <span class="st-spinner">
//               <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: rgb(255, 255, 255,0); display: block; shape-rendering: auto;" width="200px" height="200px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid"><g transform="rotate(0 50 50)"><rect x="48" y="24" rx="2" ry="2.4" width="4" height="12" fill="#000000"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.9166666666666666s" repeatCount="indefinite"/></rect></g><g transform="rotate(30 50 50)"><rect x="48" y="24" rx="2" ry="2.4" width="4" height="12" fill="#000000"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.8333333333333334s" repeatCount="indefinite"/></rect></g><g transform="rotate(60 50 50)"><rect x="48" y="24" rx="2" ry="2.4" width="4" height="12" fill="#000000"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.75s" repeatCount="indefinite"/></rect></g><g transform="rotate(90 50 50)"><rect x="48" y="24" rx="2" ry="2.4" width="4" height="12" fill="#000000"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.6666666666666666s" repeatCount="indefinite"/></rect></g><g transform="rotate(120 50 50)"><rect x="48" y="24" rx="2" ry="2.4" width="4" height="12" fill="#000000"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.5833333333333334s" repeatCount="indefinite"/></rect></g><g transform="rotate(150 50 50)"><rect x="48" y="24" rx="2" ry="2.4" width="4" height="12" fill="#000000"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.5s" repeatCount="indefinite"/></rect></g><g transform="rotate(180 50 50)"><rect x="48" y="24" rx="2" ry="2.4" width="4" height="12" fill="#000000"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.4166666666666667s" repeatCount="indefinite"/></rect></g><g transform="rotate(210 50 50)"><rect x="48" y="24" rx="2" ry="2.4" width="4" height="12" fill="#000000"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.3333333333333333s" repeatCount="indefinite"/></rect></g><g transform="rotate(240 50 50)"><rect x="48" y="24" rx="2" ry="2.4" width="4" height="12" fill="#000000"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.25s" repeatCount="indefinite"/></rect></g><g transform="rotate(270 50 50)"><rect x="48" y="24" rx="2" ry="2.4" width="4" height="12" fill="#000000"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.16666666666666666s" repeatCount="indefinite"/></rect></g><g transform="rotate(300 50 50)"><rect x="48" y="24" rx="2" ry="2.4" width="4" height="12" fill="#000000"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.08333333333333333s" repeatCount="indefinite"/></rect></g><g transform="rotate(330 50 50)"><rect x="48" y="24" rx="2" ry="2.4" width="4" height="12" fill="#000000"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite"/></rect></g><!-- [ldio] generated by https://loading.io/ --></svg>
//             </span>
//           </div>
//         </div>
//       `;

//       const response = await fetch(link.getAttribute('href'));
//       const data = await response.text();
//       const parser = new DOMParser();
//       const newDocument = parser.parseFromString(data, 'text/html');

//       document.querySelector('.product-grid')
//         .insertAdjacentHTML('beforeend', newDocument.querySelector('.product-grid').innerHTML);

    

//       document.querySelector('.pagination')
//         .replaceWith(newDocument.querySelector('.pagination'));
//       window.observer1.observe(document.querySelector('.pagination'));
//     };
//   }

  
// });


  function toggleProductGrid(lines) {
    
    const productGrid = document.getElementById('product-grid');
    
    productGrid.classList.remove('grid--6-col-desktop');
    productGrid.classList.remove('grid--4-col-desktop');
    productGrid.classList.remove('grid--2-col-desktop');
    productGrid.classList.remove('grid--1-col-desktop');
    
     if (lines === 2) {
        productGrid.classList.add('grid--2-col-desktop');
    } else if (lines === 1) {
        productGrid.classList.add('grid--1-col-desktop');
    }else if (lines === 3) {
        productGrid.classList.add('grid--4-col-desktop');
    }else if (lines === 4) {
        productGrid.classList.add('grid--6-col-desktop');
    }
    const gridButtons = document.querySelectorAll('.st-grid-changer button, st-temporary-grid-changer button');
    const currentColumns = parseInt(lines); // Assuming 'lines' is the variable containing the current column value

    gridButtons.forEach(button => {
      const buttonColumns = parseInt(button.getAttribute('data-grid-layout-columns'));
      const isActive = button.classList.contains('active');
      if (buttonColumns === currentColumns && !isActive) {
        button.classList.add('active'); // Add 'active' class
      } else if (buttonColumns !== currentColumns && isActive) {
        button.classList.remove('active'); // Remove 'active' class
      }
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    const productGrid = document.getElementById('product-grid');
    const gridButtons = document.querySelectorAll('.st-grid-changer button , st-temporary-grid-changer button');

    if (window.innerWidth <= 768) { 
        gridButtons.forEach(button => {
            const buttonColumns = parseInt(button.getAttribute('data-grid-layout-columns'));
            if (buttonColumns === 1) {
                button.classList.add('active'); // Add 'active' class to button for collection__page-products-1
            } else {
                button.classList.remove('active'); // Remove 'active' from other buttons
            }
        });
        productGrid.classList.remove('collection__page-products-1'); // Mobile-specific class removal
    }
});

document.addEventListener('DOMContentLoaded', () => {
setTimeout(() => {
  let st_collection_cart_btn = document.querySelectorAll('#collectionmodalcontainer li.grid__item .product-card-wrapper .card__content');
  if (st_collection_cart_btn.length > 0) {
    st_collection_cart_btn.forEach((button) => {
      if (!button.classList.contains("st-cart-btn")) {
        button.classList.add("st-cart-btn")
        button.innerHTML = button.innerHTML;
      }
    })
  }
}, 600)
});